import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const logo2 = '/assets/logos/vertical logo for dark bg.png';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would submit the email to your newsletter service
    console.log('Newsletter subscription:', email);
    setEmail('');
    alert('¡Gracias por suscribirte!');
  };

  return (
    <footer className="bg-primary-900 text-white pt-16 pb-8">
      <div className="container-standard px-4">
        <div className="border-b border-accent-500 border-opacity-30 pb-8 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Logo and Copyright */}
            <div className="lg:col-span-1">
                <div className="flex flex-col items-left lg:items-left">
                  <div className="w-32 h-40 overflow-hidden">
                    <img 
                      className="w-48 h-48 object-cover"
                      src={logo2} 
                      alt="DavidCorp S.R.L." 
                    />
                  </div>
                  <p className="text-left lg:text-left mt-4">© 2025 Derechos Reservados.</p>
                </div>
            </div>
            
            {/* Contact Info */}
            <div>
              <h3 className="text-xl font-bold mb-4 text-accent-400">Contacto</h3>
              <ul className="space-y-2">
                <li>491 Jr. Sta Cruz de Pachacutec,</li>
                <li>Los Olivos</li>
                <li>
                  <a
                    href="mailto:info@davidcorp-srl.com"
                    className="hover:text-accent-400 transition-colors"
                  >
                    info@davidcorp-srl.com
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+51936776570"
                    className="hover:text-accent-400 transition-colors"
                  >
                    +51 936776570
                  </a>
                </li>
                <li className="mt-4">
                  <a 
                    href="https://www.linkedin.com/company/davidcorp/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center hover:text-accent-400 transition-colors"
                  >
                    <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    </svg>
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
            
            {/* More Info */}
            <div>
              <h3 className="text-xl font-bold mb-4 text-accent-400">Más de nosotros</h3>
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/nosotros" 
                    className="hover:text-accent-400 transition-colors"
                  >
                    Sobre nosotros
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/proyectos" 
                    className="hover:text-accent-400 transition-colors"
                  >
                    Proyectos
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/noticias" 
                    className="hover:text-accent-400 transition-colors"
                  >
                    Noticias
                  </Link>
                </li>
                <li>
                  <Link
                    to="/avisos-legales"
                    className="hover:text-accent-400 transition-colors"
                  >
                    Avisos legales
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to="/privacidad"
                    className="hover:text-accent-400 transition-colors ml-4 block"
                  >
                    Política de privacidad
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terminos-y-condiciones"
                    className="hover:text-accent-400 transition-colors ml-4 block"
                  >
                    Términos y condiciones
                  </Link>
                </li>
                <li>
                  <Link
                    to="/politica-de-cookies"
                    className="hover:text-accent-400 transition-colors ml-4 block"
                  >
                    Política de cookies
                  </Link>
                </li>
                <li>
                  <Link
                    to="/libro-de-reclamaciones"
                    className="hover:text-accent-400 transition-colors ml-4 block"
                  >
                    Libro de Reclamaciones
                  </Link>
                </li>
              </ul>
            </div>
            
            {/* Newsletter */}
            <div>
              <h3 className="text-xl font-bold mb-4 text-accent-400">Boletín</h3>
              <ul className="mb-4">
                <li>Suscríbete a nuestro boletín para</li>
                <li>recibir nuestras noticias y ofertas.</li>
              </ul>
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-mail"
                  required
                  className="px-4 py-2 rounded-l text-gray-800 outline-none"
                />
                <button
                  type="submit"
                  className="bg-accent-500 hover:bg-accent-600 text-white font-medium py-2 px-4 rounded-r transition-colors whitespace-nowrap"
                >
                  Enviar
                </button>
              </form>
            </div>
          </div>
        </div>
        
        <div className="text-center text-gray-400 text-sm">
          <p>DavidCorp s.r.l. - Especialistas en ingeniería y soluciones industriales</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
